import { useUIStore } from "../stores/ui-store"
import { keys } from "../keys"

/**
 * Get the login URL with optional redirect parameter.
 * Uses DOMAINS.AUTH from the ui-store configuration.
 */
export function getLoginUrl(noRedirect?: boolean): string {
  const domains = useUIStore.getState().domains
  const authDomain = domains?.AUTH || keys.AUTH_URL

  if (noRedirect) {
    return authDomain
  }

  return `${authDomain}?redirect=${encodeURIComponent(window.location.href)}`
}

/**
 * Get the logout URL.
 */
export function getLogoutUrl(): string {
  const domains = useUIStore.getState().domains
  const authDomain = domains?.AUTH || keys.AUTH_URL
  return `${authDomain}/logout`
}

/**
 * Redirect to login page.
 * Useful for programmatic redirects after auth checks fail.
 */
export function redirectToLogin(): void {
  window.location.href = getLoginUrl()
}
